import styled from 'styled-components'

export const MainContainerLogin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`
export const ErrorMsg = styled.p`
  color: red;
`

export const MainContainerLoginDark = styled.div`
  display: flex;
  color: white;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  background-color: rgb(34, 33, 33);
`

export const InputLogin = styled.input`
  height: 6vh;
  width: 20vw;
`
export const InputLoginDark = styled.input`
  height: 6vh;
  color: white;
  border-radius: 5px;
  width: 20vw;
  border: 1px solid white;
  background-color: black;
`
export const InputItemsLogin = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
`
export const LogoLogin = styled.img`
  height: 8vh;
  width: 15vw;
  margin-left: 60px;
`
export const Card1Login = styled.div`
  box-shadow: 1px 1px 1px 1px black;
  padding: 30px;
  border-radius: 1px;
  width: 30vw;
`
export const Card1LoginDark = styled.div`
  box-shadow: 1px 1px 1px 1px black;
  padding: 30px;
  border-radius: 1px;
  width: 30vw;
  background-color: black;
`
export const PasswordCardLogin = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  align-self: center;
  margin-left: 5px;
`
export const CheckboxInputLogin = styled.input`
  height: 3vh;
  width: 3vw;
`
export const LoginButton = styled.button`
  background-color: rgb(6, 77, 210);
  color: #ffffff;
  border: 0px solid;
  outline: none;
  cursor: pointer;
  border-radius: 10px;
  width: 23vw;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7vh;
  align-self: center;
`
